var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGec1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3281 12.2685V17.8751H22.25C23.4103 17.8751 24.5231 18.336 25.3436 19.1565C26.1641 19.977 26.625 21.0898 26.625 22.2501H0.375C0.375 21.0898 0.835936 19.977 1.65641 19.1565C2.47688 18.336 3.58968 17.8751 4.75 17.8751H9.67188V12.2685C8.54373 11.4583 7.70174 10.311 7.2671 8.99185C6.83245 7.67266 6.82757 6.24959 7.25315 4.92745C7.67872 3.60532 8.51282 2.4523 9.63537 1.63436C10.7579 0.816418 12.1111 0.375732 13.5 0.375732C14.8889 0.375732 16.2421 0.816418 17.3646 1.63436C18.4872 2.4523 19.3213 3.60532 19.7469 4.92745C20.1724 6.24959 20.1675 7.67266 19.7329 8.99185C19.2983 10.311 18.4563 11.4583 17.3281 12.2685ZM0.375 26.6251V24.4376H26.625V26.6251H0.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGec1);
export default __webpack_public_path__ + "static/media/gec1.a5a88c7b6b4dd9859c0475ac125db68e.svg";
export { ForwardRef as ReactComponent };